import React from 'react';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { FeaturedIcon } from '../FeaturedIcon';
import { CloseButton } from '../common';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PopoverHeader(props) {
  var _props$buttonXClose = props.buttonXClose,
    buttonXClose = _props$buttonXClose === void 0 ? true : _props$buttonXClose,
    _props$divider = props.divider,
    divider = _props$divider === void 0 ? false : _props$divider,
    featuredIcon = props.featuredIcon,
    featuredIconColor = props.featuredIconColor,
    featuredIconSize = props.featuredIconSize,
    featuredIconTheme = props.featuredIconTheme,
    hidden = props.hidden,
    onClose = props.onClose,
    _props$showFeaturedIc = props.showFeaturedIcon,
    showFeaturedIcon = _props$showFeaturedIc === void 0 ? true : _props$showFeaturedIc,
    supportingText = props.supportingText,
    text = props.text;
  var theme = useTheme();
  return hidden ? null : /*#__PURE__*/_jsxs(Stack, {
    role: "popover-header",
    children: [/*#__PURE__*/_jsxs(Stack, {
      padding: "16px 16px 0px",
      role: "popover-header-content",
      spacing: 3,
      children: [showFeaturedIcon && featuredIcon && /*#__PURE__*/_jsxs(Stack, {
        alignItems: "center",
        direction: "row",
        justifyContent: "space-between",
        role: "featured-icon-and-close-btn",
        children: [showFeaturedIcon && featuredIcon && /*#__PURE__*/_jsx(FeaturedIcon, {
          Icon: featuredIcon,
          color: featuredIconColor,
          iconTheme: featuredIconTheme,
          size: featuredIconSize
        }), buttonXClose && /*#__PURE__*/_jsx(CloseButton, {
          height: "44px",
          onClose: onClose,
          sx: {
            '& .MuiSvgIcon-root, .zenith-icon': {
              height: '24px',
              width: '24px'
            }
          },
          width: "44px"
        })]
      }), !showFeaturedIcon && /*#__PURE__*/_jsxs(Stack, {
        spacing: 1,
        children: [/*#__PURE__*/_jsxs(Stack, {
          alignItems: "center",
          direction: "row",
          justifyContent: text === '' && supportingText === '' ? 'flex-end' : 'space-between',
          role: "text-and-close-btn",
          children: [text && /*#__PURE__*/_jsx(Typography, {
            color: theme.palette.gray[900],
            flexWrap: "wrap",
            variant: "text-lg-semibold",
            children: text
          }), !text && supportingText && /*#__PURE__*/_jsx(Typography, {
            color: theme.palette.gray[600],
            flexWrap: "wrap",
            variant: "text-sm-regular",
            children: supportingText
          }), buttonXClose && /*#__PURE__*/_jsx(CloseButton, {
            height: "44px",
            onClose: onClose,
            size: 24,
            sx: {
              '& .MuiSvgIcon-root, .zenith-icon': {
                height: '24px',
                width: '24px'
              }
            },
            width: "44px"
          })]
        }), text && supportingText && /*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[600],
          flexWrap: "wrap",
          variant: "text-sm-regular",
          children: supportingText
        })]
      }), showFeaturedIcon && featuredIcon && /*#__PURE__*/_jsxs(Stack, {
        spacing: 1,
        children: [/*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[900],
          flexWrap: "wrap",
          variant: "text-lg-semibold",
          children: text
        }), supportingText && /*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[600],
          flexWrap: "wrap",
          variant: "text-sm-regular",
          children: supportingText
        })]
      })]
    }), divider && /*#__PURE__*/_jsx(Divider, {
      color: theme.palette.gray[200],
      sx: {
        backgroundColor: 'unset',
        height: '1px',
        paddingTop: '16px'
      }
    })]
  });
}